import { render } from "./VerifyTokenPage.vue?vue&type=template&id=9e78166a"
import script from "./VerifyTokenPage.vue?vue&type=script&lang=js"
export * from "./VerifyTokenPage.vue?vue&type=script&lang=js"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__